import _ from 'lodash';
import { getDomains, YodiwoDomains } from '@API/WS';
import { isStringEmpty } from '@Utils/Micro';
import { DebugEx } from '@Utils/DebugEx';
import { YodiBoardConfiguration, YodiBoardExt, DashboardStructs, YodiBoardWSPolicy } from '@ModelViews/ModelViews';
// ================================================================================================
export function loadDomainURL(serverId: number, url: string, loadCB: (domain: YodiwoDomains) => void) {
    let domainAddress = (url.startsWith("http") ? url : "https://" + url) + "/jsdomains";

    if (_.has((window as any).YodiDomain, serverId)) {
        loadCB((window as any).YodiDomain[serverId]);
        return;
    }

    if ((window as any).YodiDomain == null)
        (window as any).YodiDomain = {};

    // fetch domains
    var tag = document.createElement("script");
    tag.src = domainAddress;
    tag.onload = (ev) => {
        (window as any).YodiDomain[serverId] = getDomains();
        loadCB(getDomains());
    }
    tag.onerror = (er) => {
        console.log(er);
    }
    document.getElementsByTagName("head")[0].appendChild(tag);
}
// ------------------------------------------------------
export function defaultYodiBoardSettings(): YodiBoardConfiguration {
    return {
        BoardAppTitle: "",
        AutoUpdate: true,
        LocationService: false,
        WidthListThreshold: 800,
        DefaultPageId: null,
        Logo: null,
        CollapsedFolders: false,
        DefaultIsListOpen: true,
        DefaultIsListEnabled: true,
        DefaultIsListFloating: false,
        PageShowTitle: true,
        Maintenance: {
            IsEnabled: false,
            Image: null,
            PrimaryMsg: null,
            SecondaryMsg: null
        },
        ToolbarIcons: [],
        GroupName: undefined,
        HideTopToolbar: false,
        HideWSConnection: false,
        WSPolicy: YodiBoardWSPolicy.Legacy,
        HideLocalizationDropdownList: false,
        HandleLocalizationFromGems: false
    };
}
// ------------------------------------------------------
export function YodiBoardToYodiboardExt(yodiBoard: DashboardStructs.YodiBoard): YodiBoardExt {
    let newYodiBoard = yodiBoard as YodiBoardExt;

    // We need to create a nodekey with cyan server inside
    if (newYodiBoard.NodeKey.split("-").length < 3) {
        newYodiBoard.CyanNodeKey = newYodiBoard.NodeKey;
        newYodiBoard.NodeKey = newYodiBoard.NodeKey + "-" + newYodiBoard.CyanServer;
    }

    // update runtime settings; parse json
    let boardSettings = defaultYodiBoardSettings();
    if (!isStringEmpty(yodiBoard.JsonSettings)) {
        try {
            // Migrate settings
            let settings = JSON.parse(yodiBoard.JsonSettings);
            if (settings.BoardAppTitle == null)
                settings.BoardAppTitle = yodiBoard.Name;

            boardSettings = _.merge({}, boardSettings, settings);
        } catch (ex) {
            DebugEx.TraceException(ex);
        }
    }
    newYodiBoard.Settings = boardSettings;
    return newYodiBoard;
}
// ------------------------------------------------------